<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  customizeSportsOrderPanel(:order="order" @onUpdate="updateSportsOrder")
  footerNav
</template>


<script>
import toolBar from "@/components/mobile/toolBar";
import customizeSportsOrderPanel from "@/components/mobile/account/customizeSportsOrderPanel";
import footerNav from "@/components/mobile/footerNav";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config";

export default {
  components: {
    toolBar,
    customizeSportsOrderPanel,
    footerNav,
    Marquee
  },
  data() {
    return {
      order: []
    };
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    defineOrder() {
      return this.$store.state.layout.order.sports;
    },
    defaultOrder() {
      return Object.keys(this.$store.state.layout.sports);
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
  },
  mounted() {
    this.initilize();
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    },
    initilize() {
      if (this.defineOrder.length > 0) {
        this.order = this.defineOrder;
      } else {
        this.order = this.defaultOrder;
      }
    },
    updateSportsOrder(e) {
      this.order = e;
      this.save();
    },
    save() {
      // this.$store.dispatch("layout/setOrder", { property: "sports", value: this.order });
      
      this.$store
        .dispatch("user/setSettings", {
          page_display: JSON.stringify({
            language: this.pageDisplay.language,
            oddsType: this.pageDisplay.oddsType,
            pageType: this.pageDisplay.pageType,
            showScoreMap: this.pageDisplay.showScoreMap,
            eventSorting: this.pageDisplay.eventSorting,
            marketType: this.pageDisplay.marketType,
            pageSize: this.pageDisplay.pageSize,
            mmoType: this.pageDisplay.mmoType,
          }),
          sports_order: JSON.stringify(this.order),
          betting: JSON.stringify({
            defaultStake: this.betting.defaultStake,
            acceptBetterOdds: this.betting.acceptBetterOdds,
            acceptAnyOdds: this.betting.acceptAnyOdds,
            autoRefreshOdds: this.betting.autoRefreshOdds,
            quickBet: this.betting.quickBet,
            defaultStakeAmount: this.betting.defaultStakeAmount,
            quickBetAmount: this.betting.quickBetAmount,
          }),
        })
        .then(
          (res) => {
            this.$store.dispatch("layout/setOrder", { property: "sports", value: this.order }).then(
              (res) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
              },
              (err) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
              }
            );
            this.initilize();
          },
          (err) => {
            this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
            this.initilize();
          }
        );
    }
  }
};
</script>
